import renderBenefitPlanPage from "../../../infrastructure/renders/BenefitPlanPage/render-benefit-plan-page";
import { findModels } from "../../../infrastructure/repository/benefit-models-repository";
import { findCompanyId } from "../../../infrastructure/repository/company-repository";
import { findFreshEmployeesWithFields } from "../../../infrastructure/employees-cache";
import { parseAvailableFilters } from "../../../infrastructure/helpers/parseAvailableFilters";
import adaptBenefitPlan from "../../../infrastructure/adapters/benefit-plan/adaptBenefitPlan";

export default async function editBenefitPlan({ name }) {
  await renderBenefitPlanPage({ isLoading: true });

  const companyId = await findCompanyId();
  const employees = await findFreshEmployeesWithFields(companyId);
  const { data: models } = await findModels();
  const modelId = models.find((model) => model.name === name)?.id;

  const availableFilters = {
    ...parseAvailableFilters({
      items: employees
        .filter(({ state }) => state !== "removed")
        .map((employee) => ({
          ...employee,
          checked: false,
        })),
      properties: [
        { name: "state", translationKey: "employees-section.employee-state" },
        { name: "taxRegime", translationKey: "employees-section.tax-regime" },
        {
          name: "payrollCompany",
          translationKey: "common-messages.business-name",
        },
        { name: "costCenter", translationKey: "common-messages.cost-center" },
      ],
    }),
    model: {
      name: "modelId",
      translationKey: "benefits-section.benefit-plan",
      options: models,
    },
  };

  await renderBenefitPlanPage({
    benefitPlan: adaptBenefitPlan({
      id: modelId,
      name,
      employees: employees.filter((employee) => employee.modelId === modelId),
    }),
    employees: employees
      .filter(({ state }) => state !== "removed")
      .map((employee) => ({
        ...employee,
        checked: employee.modelId === modelId,
      })),
    totalEmployees: employees.length,
    availableFilters,
    editMode: true,
  });
}
